import { render, staticRenderFns } from "./cardAd.vue?vue&type=template&id=9c6984b2&scoped=true&"
import script from "./cardAd.vue?vue&type=script&lang=js&"
export * from "./cardAd.vue?vue&type=script&lang=js&"
import style0 from "./cardAd.vue?vue&type=style&index=0&id=9c6984b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6984b2",
  null
  
)

export default component.exports